import $ from "jquery";
import { getDynDataOne, createGuid, getObject } from "#scripts/general_functions";
import { decodeIfNeeded } from "#templates/pages/content";
import language from "#scripts/translation";

export const btiLevel = (objs) => {
	let levels = [];
	const colors = ["blue", "green", "yellow", "red"];

	for (const obj of objs) {
		const meta = obj.meta;
		const title = getDynDataOne(meta, "b6353dc6-0199-4dc8-98f7-bb691fc86ce9", "localId").value;
		const text = getDynDataOne(meta, "3ef3c298-5c8a-46d3-8341-28e10567aeae", "localId").value;
		levels.push(`   <div class="col-lg-3 col-md-3 col-sm-6">
                            <a class="bti__level__button align-top ${colors[title]}" href="#" data-level="${title}" title="Nivå 0" data-color="blue">
                                <span class="bti__level__ball ${colors[title]}"></span>
                                <h2 class="bti__level__title">Nivå ${title}</h2>
                                <p class="bti__level__text">${text}</p>
                            </a>
                        </div>
                        <div id="mobile__steps__${title}" class="bti__stepsmobile bti__stepsmobile__${title} bti__content d-sm-none col">
                        </div>
                        `);
	}

	levels = levels.join("");

	const html = $(`  <div class="bti__level">
                        <div class="row row-eq-height">
    
                        ${levels}
                            
                        </div>
                    </div>`);
	return html;
};

export const btiStep = (objs, contenthtml = false) => {
	const steps = [];
	const colors = ["blue", "green", "yellow", "red"];
	for (const obj of objs) {
		const meta = obj.meta;
		const content = obj.obj;

		const title = getDynDataOne(meta, "2590e7de-06ab-4c46-9c20-b97c8cc327a1", "localId").value;
		const level = getDynDataOne(meta, "d60245ac-bf40-4a77-b83a-7c0e6a4edb5b", "localId").value;
		const step = getDynDataOne(meta, "20a57290-522b-4d23-803c-e7d6af92489a", "localId").value;
		const who = getDynDataOne(meta, "a4213774-6d38-4ab5-9981-cd6b4bec0019", "localId").value;
		let how = getDynDataOne(meta, "b3490587-85f4-47d9-be8c-0ef592612d09", "localId");
		if (how) {
			how = how.value;
		}
		const what = getDynDataOne(meta, "dd0cdc54-e8a1-415e-94a4-d34894c2749e", "localId").value;
		const tools = decodeIfNeeded(content.contentObject);

		let files = [];

		if (content.relatedSubscriberContents) {
			files = content.relatedSubscriberContents;
		}

		if (files.length < 1) {
			files = false;
		}

		const fileGuid = createGuid();
		const stepsHtml = `
        <div class="bti__step ${colors[level]
			}" data-level="${level}" data-filesloaded="false" data-files="${files}" data-filesid="files_${fileGuid}" data-step="${step}" data-id="${obj.contentId}" data-author="${obj.creator
			}">
            <div class="row">
                <div class="col-12">
                    <a href="#" class="bti__step__header  ${colors[level]}">
                        <span class="bti__step__nr text-center">${step}</span>
                        <span class="bti__step__icon"><span class="material-icons-outlined notranslate">arrow_downward</span></span></span>
                        <h3 class="bti__step__headertext">${title}</h3>
                    </a>
                </div>
            </div>
            <div class="bti__step__content">
                <div class="row">
                    <div class="col-md-12">
                        ${who &&
			`
                            <dl>
                                <dt>${language("BTI_WHO")}</dt>
                                <dd>
                                    ${who}
                                </dd>
                            </dl>`
			}
                        ${what &&
			`
                            <dl>
                                <dt>${language("BTI_WHAT")}</dt>
                                <dd>
                                    ${what}
                                </dd>
                            </dl>`
			}
                        ${how &&
			`
                            <dl>
                                <dt>${language("BTI_HOW")}</dt>
                                <dd>
                                    ${how}
                                </dd>
                            </dl>`
			}

                        <p class="tools">
                        
                            ${tools}
                            <ul class="files_${fileGuid}" >
                                <div class="spinner-border files__loading__spinner" role="status" id="files__loading__spinner_${fileGuid}">
                                  <span class="sr-only">Loading...</span>
                                </div>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
        `;

		steps.push(stepsHtml);

		if (contenthtml) {
			contenthtml.find(`#mobile__steps__${level}`).append(stepsHtml);
		}
	}

	const html = steps.join("");

	return html;
};

export const btiClickActions = () => {
	$("body").on("click", ".bti__level__button", function (e) {
		e.preventDefault();

		const level = $(this).data("level");
		$(".bti__level__button").removeClass("active");
		$(this).addClass("active");

		$(".bti__stepsmobile").removeClass("active");
		$(`.bti__stepsmobile__${level}`).addClass("active");

		$(".bti__step").hide();
		$(`.bti__step[data-level=${level}]`).show();
		$(`.bti__step[data-level=${level}]`).show();

		$(".bti__content").removeClass("red blue yellow green");

		if ($(this).hasClass("red")) {
			$(".bti__content").addClass("red");
		}
		if ($(this).hasClass("blue")) {
			$(".bti__content").addClass("blue");
		}
		if ($(this).hasClass("yellow")) {
			$(".bti__content").addClass("yellow");
		}
		if ($(this).hasClass("green")) {
			$(".bti__content").addClass("green");
		}
	});

	$("body").on("click", ".bti__step__header", function (e) {
		e.preventDefault();
		$(".bti__step__header").removeClass("active");

		const parent = $(this).parents(".bti__step");

		$(this).addClass("active");
		parent.find(".bti__step__content").toggle();

		const fileid = parent.data("filesid");

		if (!parent.data("filesloaded")) {
			if (parent.data("files") !== "null") {
				const files = JSON.parse(decodeURIComponent(parent.data("files")));
				const filesloaded = parent.data("filesloaded");

				if (files && filesloaded === false) {
					for (const obj of files) {
						if (obj.type === "mal_media") {
							if (obj.relations) {
								const countRelations = obj.relations.length;
								let countRelationsDone = 0;

								for (const file of obj.relations) {
									getObject(file.contentId, (data) => {
										$(`.${fileid}`).append(`<li><a href="${data.path}" aria-label="${data.filename} (${language("NAV_OPEN_I_NEW")})"  target="_blank">${data.filename} (${data.extension})</a></li>`);
										countRelationsDone++;
										if (countRelationsDone >= countRelations) {
											parent.data("filesloaded", true);
											$(`.${fileid}`).find(".files__loading__spinner").remove();
										}
									});
								}
							}
						}
					}
				} else {
					$(`.${fileid}`).find(".files__loading__spinner").remove();
					$(`#${fileid}`).html("");
				}
			} else {
				$(`.${fileid}`).find(".files__loading__spinner").remove();
			}

			$(this).attr("data-filesloaded", true);
		} else {
			$(`.${fileid}`).find(".files__loading__spinner").remove();
		}
	});
};
